import { hasStrongRtl } from './text';
const RTL = 'rtl';
const LTR = 'ltr';
export const handleTextDirectionality = (editor, node) => {
  // Guard against edge cases from pasted content
  if (node && node.childNodes) {
    Array.from(node.childNodes).forEach(childNode => {
      const childElement = childNode;
      const textContent = childNode.textContent;
      if (!textContent || textContent.trim() === '') {
        return;
      }

      // current text direction via attribute
      const curDir = editor.dom.getAttrib(childElement, 'dir');

      // direction of text in element
      const isRtl = hasStrongRtl(textContent);
      const {
        directionality
      } = editor.settings;
      if (childElement.nodeType === Node.TEXT_NODE || isRtl && directionality === RTL || !isRtl && (directionality === LTR || !directionality) || isRtl && curDir === RTL || !isRtl && curDir === LTR) {
        return;
      }
      childElement.setAttribute('dir', isRtl ? RTL : LTR);
    });
  }
};